module.exports = require("is-png");;